export const fieldInputTypes = {
  Checkboxes: 'checkboxes',
  Monetary: 'monetary',
  AlphaNumeric: 'alphanumeric'
};
